/* Lumora hx heroes: slider, flipping words, pointer parallax */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CH = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789#%&*+';

  /* ---------- flipping word ---------- */
  function FW(el) {
    if (el._fw) return; el._fw = 1;
    var words = (el.getAttribute('data-words') || '').split('|').filter(Boolean);
    if (words.length < 2) return;
    var fx = el.getAttribute('data-fx') || 'flipx', gap = (parseFloat(el.getAttribute('data-speed')) || 2.4) * 1000;
    var i = 0, busy = false, timer = null, cur = el.querySelector('.hx-fw__w'), meas = document.createElement('span');
    meas.className = 'hx-fw__w'; meas.setAttribute('aria-hidden', 'true'); meas.style.cssText = 'visibility:hidden;position:absolute;left:0;top:0;pointer-events:none';
    el.appendChild(meas);
    var simple = fx === 'type' || fx === 'scramble';
    function width(t) { meas.textContent = t; return meas.getBoundingClientRect().width; }
    function fit(t) { if (!simple) el.style.width = Math.ceil(width(t)) + 'px'; }
    function setLabel() { el.setAttribute('aria-label', words[i]); }
    fit(words[0]);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(words[i]); });
    window.addEventListener('resize', function () { fit(words[i]); });
    function active() {
      var s = el.closest('.hx__slide'); if (s && !s.classList.contains('is-on')) return false;
      if (document.hidden) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight;
    }
    function next() {
      if (busy) return; if (!active()) return;
      var from = words[i]; i = (i + 1) % words.length; var to = words[i]; setLabel();
      if (RM) { cur.textContent = to; fit(to); return; }
      busy = true;
      if (fx === 'type') {
        var n = from.length;
        (function del() { if (n > 0) { n--; cur.textContent = from.slice(0, n); setTimeout(del, 38); } else { var k = 0; (function add() { k++; cur.textContent = to.slice(0, k); if (k < to.length) setTimeout(add, 70); else busy = false; })(); } })();
        return;
      }
      if (fx === 'scramble') {
        var f = 0, steps = 16, L = Math.max(from.length, to.length);
        var iv = setInterval(function () {
          f++; var out = '';
          for (var c = 0; c < to.length; c++) out += (c < to.length * f / steps) ? to.charAt(c) : CH.charAt(Math.floor(Math.random() * CH.length));
          cur.textContent = out; if (f >= steps) { clearInterval(iv); cur.textContent = to; busy = false; }
        }, 45);
        return;
      }
      var nw = document.createElement('span'); nw.className = 'hx-fw__w in'; nw.textContent = to; el.appendChild(nw);
      cur.classList.remove('is-cur'); cur.classList.add('out'); fit(to);
      var old = cur; cur = nw; cur.classList.add('is-cur');
      setTimeout(function () { if (old.parentNode) old.parentNode.removeChild(old); cur.classList.remove('in'); busy = false; }, 620);
    }
    function loop() { timer = setTimeout(function () { next(); loop(); }, gap); }
    loop();
  }

  /* ---------- hero slider ---------- */
  function Hero(root) {
    if (root._hx) return; root._hx = 1;
    var slides = [].slice.call(root.querySelectorAll('.hx__slide')), n = slides.length, idx = 0, t = null;
    var dots = [].slice.call(root.querySelectorAll('.hx__dot')), cnt = root.querySelector('.hx__cnt b');
    var ap = root.getAttribute('data-ap') === '1' && n > 1 && !RM, iv = (parseFloat(root.getAttribute('data-int')) || 6) * 1000;
    function show(k) {
      if (n < 2) return; k = (k + n) % n; if (k === idx) return;
      slides[idx].classList.remove('is-on'); slides[idx].setAttribute('aria-hidden', 'true');
      idx = k; slides[idx].classList.add('is-on'); slides[idx].removeAttribute('aria-hidden');
      dots.forEach(function (d, j) { d.classList.toggle('is-on', j === idx); d.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
      if (cnt) cnt.textContent = (idx + 1 < 10 ? '0' : '') + (idx + 1);
      restart();
    }
    function restart() { clearTimeout(t); if (ap && !paused) t = setTimeout(function () { show(idx + 1); }, iv); }
    var paused = false;
    if (root.getAttribute('data-hover') === '1') {
      root.addEventListener('mouseenter', function () { paused = true; clearTimeout(t); });
      root.addEventListener('mouseleave', function () { paused = false; restart(); });
    }
    var pv = root.querySelector('[data-hx-prev]'), nx = root.querySelector('[data-hx-next]');
    if (pv) pv.addEventListener('click', function () { show(idx - 1); });
    if (nx) nx.addEventListener('click', function () { show(idx + 1); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
    /* swipe */
    var sx = null, sy = 0;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) show(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(t); else restart(); });
    /* theme editor */
    root.addEventListener('shopify:block:select', function (e) { var k = slides.indexOf(e.target.closest('.hx__slide')); if (k > -1) { var was = ap; ap = false; show(k); ap = was; } });
    root.addEventListener('shopify:block:deselect', function () { restart(); });
    restart();
    /* pointer parallax */
    if (root.getAttribute('data-par') === '1' && !RM && window.matchMedia('(hover:hover)').matches) {
      var els = [].slice.call(root.querySelectorAll('[data-par-k]')), raf = 0, px = 0, py = 0;
      root.addEventListener('mousemove', function (e) {
        var r = root.getBoundingClientRect(); px = (e.clientX - r.left) / r.width - .5; py = (e.clientY - r.top) / r.height - .5;
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; els.forEach(function (el) { var k = parseFloat(el.getAttribute('data-par-k')) || 0; el.style.setProperty('--prx', (px * k).toFixed(1) + 'px'); el.style.setProperty('--pry', (py * k).toFixed(1) + 'px'); }); });
      });
    }
  }

  function init(scope) {
    [].forEach.call((scope || document).querySelectorAll('.hx-fw'), FW);
    [].forEach.call((scope || document).querySelectorAll('.hx[data-hx]'), Hero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
